export enum BioLibGlobalEvent {
    openSearch = 'biolib-event-open-search',
}
